(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drone-recommendation"] && !Shopify.designMode) return;
  try {
    
console.log("Form script loaded");
const formContainer = document.getElementById('formContainer');
const resultDiv = document.getElementById('result');
const droneForm = document.getElementById('droneForm');

const droneLinks = {
    'ABZ L10': 'https://dronespraypro.com/products/abz-l10-spray-drone',
    'DJI Agras T-10': 'https://dronespraypro.com/products/dji-agras-t-10-drone',
    'DJI Agras T40': 'https://dronespraypro.com/products/dji-agras-t40-sprayer-drone',
    'DJI Agras T50': 'https://dronespraypro.com/products/dji-agras-t50-sprayer-drone',
    'ABZ L30': 'https://dronespraypro.com/products/abz-innovation-l30-spraying-drone',
    'XAG P100 PRO': 'https://dronespraypro.com/products/xag-p100-pro',
    'EAVISION J100': 'https://dronespraypro.com/products/eavision-j100',
    'TALOS T60X': 'https://dronespraypro.com/products/talos-t60x-1'
};

const drones = [
    {
        name: 'ABZ L10',
        whyPerfect: ['Affordable entry-level', 'Advanced obstacle avoidance', 'Reliable performance'],
        keyFeatures: ['10L spray tank (assumed)', 'LIDAR obstacle detection', 'User-friendly design'],
        alternative: 'DJI Agras T-10',
        additionalBenefits: ['Compact design', 'Easy to learn'],
        accessories: ['Basic maintenance kit', 'Standard battery']
    },
    {
        name: 'DJI Agras T-10',
        whyPerfect: ['Easy to learn', 'Compact design', 'Reliable performance'],
        keyFeatures: ['10L spray tank', 'User-friendly interface', 'Basic obstacle detection'],
        alternative: 'DJI Agras T40',
        additionalBenefits: ['Versatile applications', 'Higher capacity'],
        accessories: ['Basic maintenance kit', 'Standard battery']
    },
    {
        name: 'DJI Agras T40',
        whyPerfect: ['Good efficiency', 'Versatile applications', 'User-friendly'],
        keyFeatures: ['40L spray tank', 'Improved spray system', 'Moderate terrain adaptation'],
        alternative: 'ABZ L30',
        additionalBenefits: ['Stable performance', 'Adaptable to varied crops'],
        accessories: ['Extended battery', 'Maintenance toolkit']
    },
    {
        name: 'DJI Agras T50',
        whyPerfect: ['Fast coverage', 'Larger capacity', 'Advanced features'],
        keyFeatures: ['40L spray tank', 'High-speed spraying', 'Enhanced radar system'],
        alternative: 'XAG P100 PRO',
        additionalBenefits: ['Superior spray precision', 'Extended flight time'],
        accessories: ['High-capacity battery', 'Advanced repair kit']
    },
    {
        name: 'ABZ L30',
        whyPerfect: ['Stable performance', 'Reliable control', 'Adaptable'],
        keyFeatures: ['30L tank capacity', 'Flexible operation modes', 'Moderate obstacle avoidance'],
        alternative: 'DJI Agras T40',
        additionalBenefits: ['Versatile applications', 'User-friendly'],
        accessories: ['Spare propellers', 'Charging hub']
    },
    {
        name: 'XAG P100 PRO',
        whyPerfect: ['Superior spray precision', 'Terrain following', 'Extended flight time'],
        keyFeatures: ['60L tank', 'Advanced terrain radar', 'Precision spray system'],
        alternative: 'EAVISION J100',
        additionalBenefits: ['Specialty crop optimization', 'Advanced obstacle avoidance'],
        accessories: ['Terrain sensor module', 'Precision nozzle set']
    },
    {
        name: 'EAVISION J100',
        whyPerfect: ['Advanced obstacle avoidance', 'Precision control', 'Specialty crop optimization'],
        keyFeatures: ['25L tank', 'Multi-directional radar', 'Fine mist spraying'],
        alternative: 'XAG P100 PRO',
        additionalBenefits: ['Terrain following', 'Extended flight time'],
        accessories: ['Obstacle sensor kit', 'Specialty crop nozzles']
    },
    {
        name: 'TALOS T60X',
        whyPerfect: ['Maximum performance', 'Highest durability', 'Cutting-edge technology'],
        keyFeatures: ['50L spray tank', 'Heavy payload support', 'Enterprise-grade control'],
        alternative: 'DJI Agras T50',
        additionalBenefits: ['Fast coverage', 'Advanced features'],
        accessories: ['Heavy-duty battery', 'Enterprise support plan']
    }
];

droneForm.addEventListener('submit', function(e) {
    e.preventDefault();
    console.log("Form submitted");

    const operationType = document.getElementById('operationType').value;
    const fieldSize = document.getElementById('fieldSize').value;
    const priority = document.getElementById('priority').value;
    const experience = document.getElementById('experience').value;
    const features = document.getElementById('features').value;
    const budget = document.getElementById('budget').value;

    // Scoring function
    function scoreDrone(drone) {
        let score = 0;

        // Operation Type
        if (operationType === 'row_crops') {
            if (['DJI Agras T40', 'DJI Agras T50', 'TALOS T60X'].includes(drone.name)) score += 2;
            else score += 1;
        } else if (operationType === 'specialty_crops') {
            if (['XAG P100 PRO', 'EAVISION J100'].includes(drone.name)) score += 3;
            else if (['ABZ L10', 'DJI Agras T10', 'DJI Agras T40'].includes(drone.name)) score += 1;
        } else if (operationType === 'mixed_farming') {
            if (['DJI Agras T40', 'ABZ L30'].includes(drone.name)) score += 2;
            else if (drone.name === 'DJI Agras T50') score += 1;
        } else if (operationType === 'custom_services') {
            if (drone.name === 'TALOS T60X') score += 3;
            else if (drone.name === 'DJI Agras T50') score += 2;
        }

        // Field Size/Terrain
        if (fieldSize === 'small_simple') {
            if (['ABZ L10', 'DJI Agras T10'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T40') score += 1;
        } else if (fieldSize === 'medium_moderate') {
            if (['DJI Agras T40', 'ABZ L30'].includes(drone.name)) score += 3;
            else if (['DJI Agras T50', 'XAG P100 PRO'].includes(drone.name)) score += 1;
        } else if (fieldSize === 'large_complex') {
            if (['DJI Agras T50', 'TALOS T60X'].includes(drone.name)) score += 3;
            else if (drone.name === 'XAG P100 PRO') score += 2;
        } else if (fieldSize === 'multiple_varied') {
            if (['ABZ L30', 'XAG P100 PRO'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T40') score += 1;
        }

        // Priority
        if (priority === 'basic_reliability') {
            if (['ABZ L10', 'DJI Agras T10'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T40') score += 1;
        } else if (priority === 'speed_precision') {
            if (drone.name === 'DJI Agras T40') score += 3;
            else if (['DJI Agras T50', 'XAG P100 PRO'].includes(drone.name)) score += 2;
        } else if (priority === 'max_speed') {
            if (['DJI Agras T50', 'TALOS T60X'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T40') score += 1;
        } else if (priority === 'ultimate_precision') {
            if (['XAG P100 PRO', 'EAVISION J100'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T50') score += 1;
        }

        // Experience
        if (experience === 'beginner') {
            if (['ABZ L10', 'DJI Agras T10'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T40') score += 1;
        } else if (experience === 'intermediate') {
            if (['DJI Agras T40', 'ABZ L30'].includes(drone.name)) score += 2;
            else if (drone.name === 'DJI Agras T50') score += 1;
        } else if (experience === 'advanced') {
            if (['DJI Agras T50', 'XAG P100 PRO'].includes(drone.name)) score += 2;
            else if (drone.name === 'EAVISION J100') score += 1;
        } else if (experience === 'professional') {
            if (drone.name === 'TALOS T60X') score += 3;
            else if (drone.name === 'DJI Agras T50') score += 2;
        }

        // Features
        if (features === 'simple_operation') {
            if (['ABZ L10', 'DJI Agras T10'].includes(drone.name)) score += 3;
            else if (drone.name === 'DJI Agras T40') score += 2;
        } else if (features === 'obstacle_avoidance') {
            if (['ABZ L10', 'EAVISION J100'].includes(drone.name)) score += 3;
            else if (['DJI Agras T40', 'DJI Agras T50'].includes(drone.name)) score += 2;
        } else if (features === 'extended_flight') {
            if (drone.name === 'XAG P100 PRO') score += 3;
            else if (drone.name === 'DJI Agras T50') score += 1;
        } else if (features === 'heavy_payload') {
            if (drone.name === 'TALOS T60X') score += 3;
            else if (drone.name === 'DJI Agras T50') score += 2;
        } else if (features === 'terrain_following') {
            if (drone.name === 'XAG P100 PRO') score += 3;
            else if (['DJI Agras T50', 'EAVISION J100'].includes(drone.name)) score += 2;
        }

        // Budget
        if (budget === 'range1') { // Up to $15,000
            if (['ABZ L10', 'DJI Agras T-10', 'DJI Agras T40'].includes(drone.name)) score += 3;
            else if (['ABZ L30', 'XAG P100 PRO'].includes(drone.name)) score += 1;
        } else if (budget === 'range2') { // $15,001–$20,000
            if (['ABZ L30', 'XAG P100 PRO'].includes(drone.name)) score += 3;
            else if (['DJI Agras T-10', 'DJI Agras T40'].includes(drone.name)) score += 1;
            else if (['DJI Agras T50', 'EAVISION J100', 'TALOS T60X'].includes(drone.name)) score += 1;
        } else if (budget === 'range3') { // $20,001–$25,000
            if (['DJI Agras T50', 'EAVISION J100', 'TALOS T60X'].includes(drone.name)) score += 3;
            else if (['XAG P100 PRO'].includes(drone.name)) score += 1;
        }

        return score;
    }

    // Calculate scores and find the best drone
    let bestDrone = drones[0];
    let highestScore = -1;
    drones.forEach(drone => {
        const score = scoreDrone(drone);
        console.log(`${drone.name}: ${score}`);
        if (score > highestScore) {
            highestScore = score;
            bestDrone = drone;
        }
    });

    // Display Result and Hide Form
    const droneLink = droneLinks[bestDrone.name] || '#';
    document.getElementById('primaryDroneLink').href = droneLink;
    document.getElementById('primaryDroneLink').textContent = bestDrone.name;
    document.getElementById('seeDroneLink').href = droneLink;
    document.getElementById('primaryWhy').innerHTML = `<strong>Why it’s perfect for you:</strong> ${bestDrone.whyPerfect.join(', ')}`;
    document.getElementById('primaryFeatures').innerHTML = `<strong>Key features:</strong> ${bestDrone.keyFeatures.join(', ')}`;
    document.getElementById('alternativeDroneLink').href = droneLinks[bestDrone.alternative] || '#';
    document.getElementById('alternativeDroneLink').textContent = bestDrone.alternative;
    document.getElementById('alternativeBenefits').innerHTML = `<strong>Additional benefits:</strong> ${bestDrone.additionalBenefits.join(', ')}`;
    document.getElementById('accessories').innerHTML = `<strong>Recommended Accessories:</strong> ${bestDrone.accessories.join(', ')}`;
    document.getElementById('nextSteps').innerHTML = `<strong>Next Steps:</strong> Schedule a demo, explore training, or contact support.`;
    formContainer.style.display = 'none';
    resultDiv.style.display = 'block';
});

document.getElementById('backButton').addEventListener('click', function() {
    resultDiv.style.display = 'none';
    formContainer.style.display = 'block';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.getAttribute('data-sticky-type') !== 'always' || !this.querySelector('dsp-navigation')) window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      this.header.querySelector('dsp-navigation')?.dispatchEvent(new CustomEvent('dsp:nav-close', { bubbles: true }));
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
